<style src="./EditOccupation.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="edit-occupation right-panel-box" v-click-outside="closePanel">
    <span class="panel-title">Editar Ocupação</span>

    <form v-on:submit.prevent="editData">
      <textbox
        label="Nome da ocupação"
        placeholder="Ex.: Coordenador"
        v-model="occupationName" />

      <div class="comandos">
        <button class="btn-success" :enabled="saveDisabled"><icon-check />Salvar</button>
        <button
          type="button"
          class="btn-danger"
          v-shortkey="['esc']" @shortkey="cancel"
          @click="cancel"><icon-close />Cancelar</button>
      </div>
    </form>
  </section>
</template>

<script>
import { Textbox } from '@/components/primitives'
import {IconCheck, IconClose} from '@/components/primitives/icons'
import { EditOccupation } from '@/brain/record/occupation'

export default {
  name: 'Occupation',
  components: {
    Textbox,
    IconCheck,
    IconClose
  },
  props: {
    item: {
      default: null
    }
  },
  data () {
    return {
      saveDisabled: false,
      occupationName: ''
    }
  },
  mounted () {
    this.occupationName = this.item.name
  },
  methods: {
    editData () {
      this.saveDisabled = true
      EditOccupation({ _id: this.item._id, name: this.occupationName })
        .then((response) => {
          this.saveDisabled = false
          this.occupationName = ''
          this.$emit('success')
          this.closePanel()
        })
    },
    closePanel () {
      this.$emit('cancel')
    },
    cancel (e) {
      e.stopPropagation()
      this.closePanel()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/occupation/right-panel/edit-occupation/EditOccupation.vue